export default {
   serverUrl: 'http://discovery-fhir.eba-az3mg9m9.us-east-1.elasticbeanstalk.com:8081',
   timeout: 5000,			// msec

   normalDotRadius: '5px',
   highlightDotRadius: '7.5px',

   textSizeStep: 0.04,
   minTextSize: 0.80,
   maxTextSize: 1.16,

   maxSinglePeriods: 15,		// Maximum single years/months to show in timeline

   searchMaxLength: 200,
   searchShowSearching: 10000,		// Number of search references before showing "Searching..." in status
   searchMaxWordLength: 25,		// Do not index "words" longer than this (cheap GUID-like exclusion)

   showViewHelp: false,			// show view help?
   viewHelpCloseTime: 5,		// seconds before "auto-close" view help (0 --> no auto-close)
   viewHelpCloseCountdown: false,	// true --> show countdown of remaining time before closing view help

   summaryViewMaxMRNChars: 8,

   timeWidgetThumbResetZone: 0.0035,	// Width of thumb "reset" zones in fraction of timeWidget width

   contentPanelDragUpdateInterval: 0,	// Msec between position updates during ContentPanel drag operations
//   contentPanelUseWindowing: 200,	// min number of displayable resources to use virtual/windowed display
   contentPanelUseWindowing: 100000,	// Feature is incomplete, so disable by default

   // Enabled/disabled items
   enableSearch: false,
   enableMenu: false,
   enableTextSizing: false,

   enablePayer: false,
   enableCollections: false,
   enablePathfinder: false,
   enableConsult: false,
   enableDiabetes: false,

   enableContentPanelLeftRight: false,
   enableShowLess: false,
   enableReportedMultProvs: false,
   enableOnlyRecordsWithNotes: false,
}
